import { useState } from "react";
import "./AddTaskForm.css";

function AddTaskForm({ onAdd }) {
  const [Task, setTask] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (Task.trim() !== "") {
      onAdd(Task);
      setTask("");
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} className="container">
        <input
          type="text"
          placeholder="Write your Task here"
          value={Task}
          onChange={(e) => setTask(e.target.value)}
          className="inputStyling"
        />
        <button type="Submit" className="AddButton">
          Add
        </button>
      </form>
    </>
  );
}

export default AddTaskForm;
